<template>
  <button :class="classes" @click="onClick">
    <div class="trbo-a-question-next-button__wrapper">
      <icon name="next" class="trbo-a-question-next-button__icon" />
      <div class="trbo-a-question-next-button__title">
        {{ $t('wizard.next') }}
      </div>
    </div>
  </button>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  computed: {
    classes () {
      return {
        'question-next-button': true
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click', 'next')
    }
  }
}
</script>

<style scoped src="./next-button.scss" />
